const { createBrowserHistory: CreateBrowserHistory } = require('history');

const internals = {};

internals.isCordovaBootUrl = (pathname) => /\.html$/i.test(pathname || '');

const history = CreateBrowserHistory({
    basename: __BASENAME__
});

if (typeof window !== 'undefined' && window.cordova && internals.isCordovaBootUrl(history.location.pathname)) {
    history.replace({
        pathname: '/',
        search: history.location.search,
        hash: history.location.hash
    });
}

module.exports = history;
module.exports.internals = internals;
